import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: #0A3B2D;
  color: white;
  padding: 4rem 5% 2rem;
  position: relative;
  overflow: hidden;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  position: relative;
  z-index: 2;
`;

const LogoContainer = styled.div`
  margin-bottom: 1.5rem;
  
  img {
    height: 40px;
    width: auto;
  }
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    color: white;
    position: relative;
    padding-bottom: 0.75rem;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 2px;
      background: linear-gradient(90deg, #4CAF50, #8BC34A);
    }
  }
`;

const ContactInfo = styled.div`
  p {
    margin: 0.5rem 0;
    color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: flex-start;
    line-height: 1.6;
    
    svg {
      margin-right: 0.75rem;
      margin-top: 0.25rem;
      flex-shrink: 0;
    }
  }
`;

const LinksList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  
  li {
    margin-bottom: 0.75rem;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    a {
      color: rgba(255, 255, 255, 0.8);
      text-decoration: none;
      transition: all 0.3s ease;
      display: inline-block;
      
      &:hover {
        color: white;
        transform: translateX(5px);
      }
    }
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 4rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
`;

const EmailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const scrollToSection = (e, sectionId) => {
  e.preventDefault();
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
    // Update URL without adding to history
    window.history.pushState(null, '', `#${sectionId}`);
  }
};

const Footer = () => {
  return (
    <FooterContainer>
      <Content>
        <div>
          <LogoContainer>
            <img src="/1.svg" alt="Surevest Logo" style={{ height: '40px' }} />
          </LogoContainer>
          <p style={{ color: 'rgba(255, 255, 255, 0.7)', lineHeight: '1.7', marginBottom: '1.5rem' }}>
            Empowering businesses with innovative financial solutions for sustainable growth and success.
          </p>
        </div>
        
        <FooterSection>
          <h3>Quick Links</h3>
          <LinksList>
            <li>
              <a 
                href="#services" 
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#services').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Our Services
              </a>
            </li>
            <li>
              <a 
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#about').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Meet the Team
              </a>
            </li>
            <li>
              <a 
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Contact Us
              </a>
            </li>
          </LinksList>
        </FooterSection>
        
        <FooterSection>
          <h3>Contact Info</h3>
          <ContactInfo>
            <p>
              <EmailIcon />
              <a href="mailto:info@3bs.co.za" style={{color: 'inherit', textDecoration: 'none'}}>info@3bs.co.za</a>
            </p>
          </ContactInfo>
        </FooterSection>
        
        <FooterSection>
          <h3>Services</h3>
          <LinksList>
            <li>
              <a 
                href="#services"
                onClick={(e) => scrollToSection(e, 'services')}
              >
                Smart Financial Management
              </a>
            </li>
            <li>
              <a 
                href="#services"
                onClick={(e) => scrollToSection(e, 'services')}
              >
                Local Market Expertise
              </a>
            </li>
            <li>
              <a 
                href="#services"
                onClick={(e) => scrollToSection(e, 'services')}
              >
                Time-Saving Automation
              </a>
            </li>
            <li>
              <a 
                href="#services"
                onClick={(e) => scrollToSection(e, 'services')}
              >
                Secure & Compliant
              </a>
            </li>
          </LinksList>
        </FooterSection>
      </Content>
      
      <Copyright>
        &copy; {new Date().getFullYear()} Surevest. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer;
